jQuery(function($) {
    $.app = {};
    $.app.document = $(document);
    $.app.dashboard = $('.dokan-dashboard-wrap');

    if ( ! $.app.dashboard.length ) {
        return;
    }

    $.app.dashboard.header = $.app.dashboard.find('.mobile-vendor-header');
    $.app.dashboard.menu = $.app.dashboard.find('.dokan-dashboard-menu');
    $.app.dashboard.productEditForm = $.app.dashboard.find('.dokan-product-edit-form');

    /**
     * Hamburger menu button toggler
     * 
     * @since 1.0.0
     * 
     * @author Matthew Yermakov <matvey@modeeffect.com>
     */
    $.app.dashboard.header.on('click', '#dokan-hamburger-menu', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $menu = $.app.dashboard.menu;

        $this.find('i.fa-bars, i.fa-close').toggleClass('fa-bars fa-close');
        $menu.toggleClass('active');
    });

    /**
     * Submenu items handler for seller dashboard
     * 
     * @since 1.0.0
     * 
     * @author Matthew Yermakov <matvey@modeeffect.com>
     */
    $.app.dashboard.menu.find('li.has-submenu > a').on('click', function(e) {
        if ( $(window).width() > 768 ) {
            // If the window width is less than 768px, do not toggle the submenu
            return;
        }

        e.preventDefault();

        const $this = $(this);
        const $parent = $this.parent();

        // Toggle active class
        if ($parent.hasClass('active')) {
            $parent.removeClass('active');
        } else {
            $.app.dashboard.menu.find('li.has-submenu').removeClass('active');

            $parent.addClass('active');
        }
    });

    $.app.document.ready(function() {
        /**
         * Select variable product automatically
         * and hide select, add heading instead
         * of select
         * 
         * @since 1.0.1
         * 
         * @author Matthew Yermakov <matvey@modeeffect.com>
         */
        const productTypeSelect = $.app.dashboard.productEditForm.find('select[name="product_type"]');

        productTypeSelect.val('variable').trigger('change');
        productTypeSelect.parent().css('display', 'none');
        
        $('<p class="variable-product">Variable</p>').insertAfter(productTypeSelect);

        /**
         * If adding brands is allowed
         * then initialize a custom select2
         * handler for the multiple select on the 
         * edit/add product page
         * 
         * @see wp-content/plugins/wedlender/templates/dokan/products/edit-product-single.php
         * 
         * @since 1.0.3
         * @author Matthew Yermakov
         */
        if ( $('#wl_product_brand_edit').length !== 0 ) {
            $('#wl_product_brand_edit').select2({
                allowClear: true,
                minimumInputLength: 0,
                tags: true,
                ajax: {
                    url: dokan.ajaxurl,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            action: 'dokan_json_search_products_brands',
                            security: dokan.search_products_brands_nonce,
                            page: ! params.term ? 1 : undefined
                        };
                    },
                    processResults: function (data) {
                        const results = Array.isArray(data)
                        ? data.map(function(item) {
                            return {
                                id: item[0],
                                text: item[1]
                            };
                        })
                        : [];

                        return { results: results };
                    },
                },
                createTag: function (params) {
                    return {
                        id: params.term,
                        text: params.term,
                        newTag: true
                    };
                }
            });
        }
    });
});